var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./MultipleChoiceQuestion.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-53362aa7\",\"hasScoped\":false}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./MultipleChoiceQuestion.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/quizzes/questions/MultipleChoiceQuestion.vue
// module id = 113
// module chunks = 1